"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === _helmConstants.HELM_BUILT) {
    return _extends({}, state, _defineProperty({}, action.pkgName, {
      chartPath: action.chartPath
    }));
  }
  return state;
};

var _helmConstants = require("./helmConstants");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {};
//# sourceMappingURL=helmReducer.js.map


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/dist/helm/helmReducer.js
// module id = 248
// module chunks = 0